<script>
    import { goto } from "$app/navigation";
    import DraftPicture from "./assets/features/Draft Picture 4.png";
    import QualifyPicture from "./assets/features/Qualify Picture 1.png";
    import ReviewPicture from "./assets/features/Review Picture 1.png";
</script>

<!-- Mobile layout -->
<div class="md:hidden px-6 py-10 flex flex-col gap-8 items-center text-center">
    <h1 class="font-bold text-[42px] leading-[50px] text-navy">
        Your <span class="ai-gradient-text">AI Tool</span> for UK R&D Tax Narratives
    </h1>
    <p class="text-[18px] leading-normal font-medium text-purple-sub">
        Save time &amp; supercharge robustness via responsible use of AI
    </p>
    <div class="flex gap-4 items-center justify-center flex-wrap">
        <button
            class="bg-navy text-white h-[48px] px-[20px] rounded-[40px] text-[15px] font-semibold hover:opacity-90 transition whitespace-nowrap"
            on:click={() => { window.location.href = "#contact"; }}
        >
            Request a demo
        </button>
        <button
            class="h-[48px] px-[20px] rounded-[40px] text-[15px] font-semibold hover:opacity-90 transition whitespace-nowrap border"
            style="background-color: #e5e7fb; border-color: #e5e7fb; color: #050c3b;"
            on:click={() => goto("/login")}
        >
            Log in
        </button>
    </div>
    <div class="w-full rounded-[12px] overflow-hidden bg-[rgba(255,255,255,0.53)] shadow-[12px_10px_52px_0px_rgba(117,81,174,0.20)] p-4 flex flex-col gap-3">
        <img src={DraftPicture} alt="Draft" class="w-full rounded-[8px] shadow" />
        <img src={QualifyPicture} alt="Qualify" class="w-full rounded-[8px] shadow" />
        <img src={ReviewPicture} alt="Review" class="w-full rounded-[8px] shadow" />
    </div>
</div>

<!-- Desktop layout (original) -->
<div class="hidden md:block relative w-full" style="height: 683px;">
    <div class="relative max-w-[1440px] mx-auto h-full">

        <div class="absolute pointer-events-none flex items-center justify-center" style="left: 855.04px; top: -98.77px; width: 861.05px; height: 787.624px;">
            <div class="-scale-y-100 rotate-[106.52deg] flex-none">
                <div class="bg-gradient-to-b from-[rgba(239,223,180,0.49)] via-[rgba(138,97,233,0.49)] to-[rgba(12,19,214,0.7)] rounded-[160px] blur-[90px]" style="width: 608.692px; height: 717.578px;"></div>
            </div>
        </div>

        <div class="absolute pointer-events-none flex items-center justify-center" style="left: 883.49px; top: 47.08px; width: 530.879px; height: 387.288px;">
            <div class="rotate-[2.94deg] flex-none w-full h-full rounded-full blur-[50px]" style="background-color: rgba(82, 102, 235, 0.4);"></div>
        </div>

        <div class="absolute pointer-events-none" style="left: 1122px; top: 382px; width: 248px; height: 248px;">
            <div class="w-full h-full rounded-full blur-[50px]" style="background-color: rgba(173, 122, 255, 0.3);"></div>
        </div>

        <div class="absolute flex flex-col gap-[40px] items-start" style="left: 104px; top: 118px; width: 667px;">
            <h1 class="font-bold text-[70px] leading-[84px] text-navy">
                Your <span class="ai-gradient-text">AI Tool</span> for UK R&D Tax Narratives
            </h1>
            <p class="text-[20px] leading-normal font-medium text-purple-sub">
                Save time &amp; supercharge robustness<br />via responsible use of AI
            </p>
            <div class="flex gap-[24px] items-center">
                <button
                    class="bg-navy text-white h-[52px] px-[24px] rounded-[40px] text-[16px] font-semibold hover:opacity-90 transition whitespace-nowrap"
                    on:click={() => { window.location.href = "#contact"; }}
                >
                    Request a demo
                </button>
                <button
                    class="h-[52px] px-[24px] rounded-[40px] text-[16px] font-semibold hover:opacity-90 transition whitespace-nowrap border"
                    style="background-color: #e5e7fb; border-color: #e5e7fb; color: #050c3b;"
                    on:click={() => goto("/login")}
                >
                    Log in
                </button>
            </div>
        </div>

        <div class="absolute bg-[rgba(255,255,255,0.53)] rounded-[12px] shadow-[12px_10px_52px_0px_rgba(117,81,174,0.20)] overflow-hidden" style="left: 921px; top: 78px; width: 603px; height: 527px;">
            <div class="absolute rounded-[12px] overflow-hidden shadow-[0px_3px_12px_0px_rgba(48,49,133,0.10)]" style="left: 59px; top: 58px; width: 434px; height: 134px;">
                <img src={DraftPicture} alt="Draft" class="absolute max-w-none top-0 left-[-0.02%]" style="width: 197.05%; height: auto;" />
            </div>
            <div class="absolute rounded-[12px] overflow-hidden shadow-[0px_3px_12px_0px_rgba(48,49,133,0.10)]" style="left: 59px; top: 199px; width: 434px; height: 133px;">
                <img src={QualifyPicture} alt="Qualify" class="absolute max-w-none top-0 left-[-0.02%]" style="width: 197.05%; height: auto;" />
            </div>
            <div class="absolute rounded-[12px] overflow-hidden shadow-[0px_3px_12px_0px_rgba(48,49,133,0.10)]" style="left: 60px; top: 339px; width: 434px; height: 134px;">
                <img src={ReviewPicture} alt="Review" class="absolute max-w-none top-0 left-[-0.02%]" style="width: 197.05%; height: auto;" />
            </div>
        </div>

    </div>
</div>

<style>
    .ai-gradient-text {
        background: linear-gradient(90deg, #2a3ec0 0%, #6863e8 44%, #cbb0f6 88%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
</style>
